import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import clsx from "clsx";
import DistributionPlanVerifiedIcon from "../../distribution-plan-tool/common/DistributionPlanVerifiedIcon";
import type { Suggestion } from "../types";
import { shortenAddress } from "@/helpers/address.helpers";
import { formatFloor } from "../utils/formatting";
interface NftSuggestItemProps {
  readonly suggestion: Suggestion;
  readonly isActive: boolean;
  readonly index: number;
  readonly style: React.CSSProperties;
  readonly onHover: (index: number) => void;
  readonly onSelect: (item: Suggestion) => void;
  readonly disabled?: boolean | undefined;
}
export function NftSuggestItem(t0) {
  const $ = _c(57);
  const {
    suggestion,
    isActive,
    index,
    style,
    onHover,
    onSelect,
    disabled
  } = t0;
  const t1 = `nft-suggestion-${index}`;
  const t2 = disabled ? "tw-cursor-not-allowed tw-border-transparent tw-bg-iron-900/50 tw-opacity-50" : isActive ? "tw-cursor-pointer tw-border-primary-500 tw-bg-iron-800" : "tw-cursor-pointer tw-border-transparent tw-bg-iron-900 hover:tw-bg-iron-800";
  let t3;
  if ($[0] !== t2) {
    t3 = clsx("tw-flex tw-h-[calc(100%-8px)] tw-w-full tw-items-center tw-gap-4 tw-rounded-xl tw-border tw-px-4 tw-text-left tw-transition-all", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] !== disabled || $[3] !== index || $[4] !== onHover) {
    t4 = () => !disabled && onHover(index);
    t5 = () => !disabled && onHover(index);
    $[2] = disabled;
    $[3] = index;
    $[4] = onHover;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== disabled || $[8] !== onSelect || $[9] !== suggestion) {
    t6 = () => !disabled && onSelect(suggestion);
    $[7] = disabled;
    $[8] = onSelect;
    $[9] = suggestion;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== suggestion.imageUrl) {
    t7 = <div className="tw-h-full tw-w-full tw-overflow-hidden tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/10">{suggestion.imageUrl ? <Image src={suggestion.imageUrl} alt="" fill={true} sizes="40px" className="tw-h-full tw-w-full tw-object-cover" /> : <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-iron-800 tw-text-[10px] tw-font-bold tw-text-iron-500">NFT</div>}</div>;
    $[11] = suggestion.imageUrl;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== suggestion.safelist) {
    t8 = suggestion.safelist === "verified" && <div className="tw-absolute -tw-right-1 -tw-top-1 tw-z-10 tw-translate-x-1/2 -tw-translate-y-1/2"><DistributionPlanVerifiedIcon /></div>;
    $[13] = suggestion.safelist;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="tw-relative tw-h-10 tw-w-10 tw-shrink-0">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== suggestion.address || $[19] !== suggestion.name) {
    t10 = suggestion.name ?? shortenAddress(suggestion.address);
    $[18] = suggestion.address;
    $[19] = suggestion.name;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <span className="tw-truncate tw-text-sm tw-font-semibold tw-text-white">{t10}</span>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== suggestion.address) {
    t12 = shortenAddress(suggestion.address);
    $[23] = suggestion.address;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <span className="tw-font-mono">{t12}</span>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== suggestion.tokenType) {
    t14 = suggestion.tokenType && <><span className="tw-h-1 tw-w-1 tw-rounded-full tw-bg-iron-700" /><span>{suggestion.tokenType}</span></>;
    $[27] = suggestion.tokenType;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-text-iron-400">{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15) {
    t16 = <div className="tw-flex tw-min-w-0 tw-flex-col">{t11}{t15}</div>;
    $[32] = t11;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== suggestion.floorPriceEth) {
    t17 = <div className="tw-flex tw-w-20 tw-flex-col tw-items-end">{typeof suggestion.floorPriceEth === "number" && !Number.isNaN(suggestion.floorPriceEth) ? <><span className="tw-text-iron-400">Floor</span><span className="tw-font-medium tw-text-white">{formatFloor(suggestion.floorPriceEth)} ETH</span></> : <span className="tw-text-iron-600">—</span>}</div>;
    $[35] = suggestion.floorPriceEth;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== suggestion.totalSupply) {
    t18 = <div className="tw-flex tw-w-16 tw-flex-col tw-items-end">{suggestion.totalSupply ? <><span className="tw-text-iron-400">Supply</span><span className="tw-font-medium tw-text-white">{suggestion.totalSupply}</span></> : <span className="tw-text-iron-600">—</span>}</div>;
    $[37] = suggestion.totalSupply;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t17 || $[40] !== t18) {
    t19 = <div className="tw-flex tw-items-center tw-gap-4 tw-text-xs">{t17}{t18}</div>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t16 || $[43] !== t19) {
    t20 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-between tw-gap-4">{t16}{t19}</div>;
    $[42] = t16;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== disabled || $[46] !== t20 || $[47] !== t3 || $[48] !== t4 || $[49] !== t5 || $[50] !== t6 || $[51] !== t9) {
    t21 = <button type="button" disabled={disabled} className={t3} onMouseEnter={t4} onFocus={t5} onClick={t6}>{t9}{t20}</button>;
    $[45] = disabled;
    $[46] = t20;
    $[47] = t3;
    $[48] = t4;
    $[49] = t5;
    $[50] = t6;
    $[51] = t9;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== style || $[54] !== t1 || $[55] !== t21) {
    t22 = <li id={t1} className="tw-absolute tw-w-full tw-px-2" style={style}>{t21}</li>;
    $[53] = style;
    $[54] = t1;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  return t22;
}